/* eslint-disable jsx-a11y/anchor-is-valid */
import './AppTipModal.less';
import { SvgIcon, Modal, Loading, Button } from '@/components';
import { ParseAppStatus } from '@/shared';

export interface AppTipModalProps {
  visible: boolean;
  closeLabel: string;
  onClose?: () => void;
  state: number;
}

export function AppTipModal(
  props: AppTipModalProps & React.HTMLAttributes<HTMLDivElement>,
) {
  const { visible, onClose, state = ParseAppStatus.Inprocess } = props;

  return (
    <Modal visible={visible} className="app-tip-modal">
      {state === ParseAppStatus.Fail ? (
        <div className="tc w100">
          <SvgIcon
            className="cursor"
            style={{ fill: '#0476EB' }}
            name="error"
            width="145"
            height="145"
          />
          <p className="title">未获取</p>
          <p className="desc">
            未成功获取到 app 中的 MIUI 小部件信息，
            <br />
            请前往应用商店，上传带有 MIUI 小部件的 app
          </p>
          <Button
            className="dbi"
            type="primary"
            href={'https://dev.mi.com/distribute'}
          >
            应用商店
          </Button>
          <Button
            className="mt20 dbi"
            onClick={() => {
              onClose && onClose();
            }}
          >
            {props.closeLabel}
          </Button>
          {/* <div className="tip-box">
            <p className="tip">
              查看
              <a
                className="mag-link"
                target="_blank"
                href="https://dev.mi.com/console/doc/detail?pId=2454" rel="noreferrer"
              >
                《MIUI 小部件适配规范》
              </a>
            </p>
            <p className="tip">进一步了解 MIUI小部件</p>
          </div> */}
        </div>
      ) : (
        <div className="tc w100">
          <Loading loading={true}>
            <div style={{ width: '145px', height: '145px' }}></div>
          </Loading>
          <p className="title">正在获取...</p>
          <p className="desc">
            正在获取 app 中的 MIUI 小部件信息，
            <br />
            包体较大时，解析时间较长，请耐心等待
          </p>
          <Button
            disable
            type="primary"
            className="dbi"
            href={'https://dev.mi.com/console/doc/detail?pId=2457'}
          >
            小部件创建管理操作指南
          </Button>
          <Button
            className="mt20 dbi"
            onClick={() => {
              onClose && onClose();
            }}
          >
            返回
          </Button>

          {/* <div className="tip-box">
            <p className="tip">
              查看
              <a
                className="mag-link"
                target="_blank"
                rel="noreferrer"
                href={'https://dev.mi.com/console/doc/detail?pId=2457'}
              >
                《小部件创建管理操作指南》
              </a>
            </p>
            <p className="tip">或返回不会中断小部件获取</p>
          </div> */}
        </div>
      )}
    </Modal>
  );
}
